// Favre — mega menu „Katalog” (2026-10-23): otwieranie po najechaniu myszą (tylko urządzenia z hover).
// Animacje w CSS (favre-base.css): .is-open = panel odsłania się, karty wchodzą kolejno; zamykanie: .is-closing,
// a details.open = false dopiero po przejściu (inaczej panel znikałby od razu).
// Klik myszą w „Katalog” = przejście do katalogu; klawiatura (Enter/Spacja) rozwija panel, Esc zamyka.
(() => {
  const hover = matchMedia('(hover: hover) and (pointer: fine)');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const init = () => {
    document.querySelectorAll('[data-fmega]').forEach((d) => {
      if (d.__fmega) return;
      d.__fmega = true;
      const li = d.closest('li') || d;
      const summary = d.querySelector('summary');
      const link = d.querySelector('.fmega__alle');
      let tZamknij = 0;
      let tKoniec = 0;

      const otworz = () => {
        clearTimeout(tZamknij);
        clearTimeout(tKoniec);
        d.classList.remove('is-closing');
        if (!d.open) d.open = true;
        // klasa w następnej klatce, żeby przejście ruszyło od stanu zamkniętego
        requestAnimationFrame(() => requestAnimationFrame(() => d.classList.add('is-open')));
      };
      const zamknij = (od_razu) => {
        clearTimeout(tKoniec);
        if (!d.open) return;
        if (od_razu || reduce.matches) {
          d.classList.remove('is-open', 'is-closing');
          d.open = false;
          return;
        }
        d.classList.add('is-closing');
        d.classList.remove('is-open');
        tKoniec = setTimeout(() => {
          d.open = false;
          d.classList.remove('is-closing');
        }, 340);
      };

      li.addEventListener('mouseenter', () => { if (hover.matches) otworz(); });
      li.addEventListener('mouseleave', () => {
        if (!hover.matches) return;
        clearTimeout(tZamknij);
        tZamknij = setTimeout(() => zamknij(false), 120);
      });
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        // e.detail > 0 = kliknięcie myszą (klawiatura daje 0)
        if (hover.matches && e.detail > 0 && link) {
          location.href = link.href;
          return;
        }
        if (d.open && d.classList.contains('is-open')) zamknij(false);
        else otworz();
      });
      d.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && d.open) { zamknij(false); summary.focus(); }
      });
      // Dawn (header-menu) zamyka <details> np. po kliknięciu obok — wtedy zdejmujemy klasy
      d.addEventListener('toggle', () => {
        if (!d.open) d.classList.remove('is-open', 'is-closing');
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
